<div class="add-task-wrapper">
  <div class="heading-wrapper">
    <h3 class="ion-text-center title" *ngIf="task._id">
      {{'TASKS.EDIT_TASK' | translate}}
    </h3>
    <h3 class="ion-text-center title" *ngIf="!task._id">
      {{'TASKS.ADD_TASK' | translate}}
    </h3>
    <button class="close-btn" (click)="closeModal()"><i class="fa fa-times"></i></button>
  </div>
  <div class="content-wrapper">
    <ion-list>
      <label class="field-label" for="task-title">Task Title</label>
      <ion-item>
        <ion-input id="task-title" [(ngModel)]="task.title" (ngModelChange)="onTitleChange()" [placeholder]="'e.g. Morning medication'"></ion-input>
      </ion-item>
      <div class="error-msg" *ngIf="titleError">{{titleError}}</div>
      <label class="field-label" for="task-description">Task Description *</label>
      <ion-item>
        <ion-textarea id="task-description" rows="5" [(ngModel)]="task.description" (ngModelChange)="onDescriptionChange()"
          placeholder="What the contractor needs to do"></ion-textarea>
      </ion-item>
      <div class="error-msg" *ngIf="descriptionError">{{descriptionError}}</div>
    </ion-list>
    <div class="action-container">
      <button class="save-btn" (click)="addTask()">
        {{'TASKS.SAVE' | translate}}
      </button>

    </div>
  </div>

</div>